import React from "react";
import "./panel.scss";
import SiteTexts from "utils/Texts";
import { Labels } from "utils/Labels";
import Table from "components/Table/Table";
import TextInput from "components/Input/TextInput";
import { onlyNumber } from "utils/rejex";

interface Props {
  listAgentData: any;
  listAgentDataGot: boolean;
  searchHandler: () => void;
  nameQuery: string;
  setNameQuery: React.Dispatch<React.SetStateAction<string>>;
  mobileQuery: string;
  setMobileQuery: React.Dispatch<React.SetStateAction<string>>;
  setPageNumber:React.Dispatch<React.SetStateAction<number>>;
}

const ListAgentPage: React.FC<Props> = ({
  listAgentData,
  listAgentDataGot,
  searchHandler,
  nameQuery,
  setNameQuery,
  mobileQuery,
  setMobileQuery,
  setPageNumber,
}) => {
  const SiteText = SiteTexts();

  const TableHeader = [
    "Full Name",
    "Mobile",
    "Email Address",
    "Active",
    "Profile Image",
    "Action",
  ];

  return (
    <div className="list-agent-parent">
      <div className="search-box-parent">
        <h4>{SiteText.PROPERTY_LIST.REFINE_YOUR_SEARCH}</h4>
        <div className="search-box-content-parent">
          <form onSubmit={searchHandler}>
            <div className="text-input-parent">
              <TextInput
                lable={Labels.InputLabels.Name}
                className={"general-select-input"}
                error={""}
                value={nameQuery}
                required={false}
                name={"inpute-name"}
                onChangeValue={setNameQuery}
                autoFocus={false}
                regex={""}
                type={"text"}
                removeLable={false}
              />
            </div>
            <div className="text-input-parent">
              <TextInput
                lable={Labels.InputLabels.Mobile}
                className={"general-select-input"}
                error={""}
                value={mobileQuery}
                required={false}
                name={"inpute-mobile"}
                onChangeValue={setMobileQuery}
                autoFocus={false}
                regex={onlyNumber}
                type={"tel"}
                removeLable={false}
              />
            </div>
            <div className="text-input-parent"></div>
            <div className="submit-search-input-parent">
              <button onSubmit={searchHandler}>
                {Labels.ButtonLabels.SEARCH}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="table-main-parent-content">
        <div className="list-agent-table-parent">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <h4>{SiteText.LIST_AGENT.AGENT_LIST}</h4>
          </div>
          {listAgentDataGot ? (
            <Table
              TableHeader={TableHeader}
              TableContent={listAgentData.data}
              TableContentName={"listAgent"}
              HeaderMinWidth={["140px", "90px", "240px", "90px", "90px", "60px"]}
              currentPage={listAgentData.page}
              totalPage={Math.ceil(listAgentData.total / listAgentData.size)}
              setPageNumber={setPageNumber}
            />
          ) : (
            <></>
          )}{" "}
        </div>
      </div>
    </div>
  );
};

export default ListAgentPage;
